import React, {FC, useState} from 'react';
import CoverImage, {CoverImageProps} from 'components/ContentPagesComponents/CoverImage';
import {ModalProps} from 'utils/types/modal';

export interface PopupCoverImageProps extends Omit<CoverImageProps, 'onClick'> {
	component: FC<ModalProps>;
}

export const PopupCoverImage: FC<PopupCoverImageProps> = ({
	component: Component,
	...props
}) => {
	const [show, setShow] = useState(false);

	const handleShow = () => {
		setShow(true);
	};

	const handleClose = () => {
		setShow(false);
	};

	return (
		<>
			<Component {...props} show={show} onClose={handleClose} />
			<CoverImage {...props} onClick={handleShow} />
		</>
	);
};
